import actionTypes from 'app/actions/action-types';

export default (state = false, action) => {
  switch (action.type) {
    case actionTypes.SAVE_THEME_FAILURE:
    case actionTypes.SAVE_THEME_REQUEST: {
      return action.error;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/reducers/theme/error.js